import { render } from "./AccountThreads.vue?vue&type=template&id=04a4ecaa"
import script from "./AccountThreads.vue?vue&type=script&lang=js"
export * from "./AccountThreads.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__